import { isExpired, decodeToken } from "react-jwt";

const decodeTokenData = (token) => {
  if (typeof token !== "string" || !token) return null;

  const data = decodeToken(token);
  return data && typeof data === "object" && !Array.isArray(data)
    ? data
    : null;
};

export const setToken = (nameToken, token) => {
  window.localStorage.setItem(nameToken, JSON.stringify(token));
};

export const getToken = (nameToken) => {
  try {
    if (!localStorage) return null;

    const tokenJson = window.localStorage.getItem(nameToken);

    if (!tokenJson) return null;

    const token = JSON.parse(tokenJson);
    return token;
  } catch (error) {
    return null;
  }
};

export const deleteToken = (nameToken) => {
  window.localStorage.removeItem(nameToken);
};

export const verifyExpireTokenRefresh = () => {
  const token = getToken("etknre");

  if (!token) return true;

  const isTokenExpired = isExpired(token);
  return isTokenExpired;
};

export const decodeRefreshToken = (token) => {
  const { uid } = decodeTokenData(token) || {};
  return uid;
};

export const getSessionData = () => {
  if (verifyExpireTokenRefresh()) return null;

  const token = getToken("dttkn");
  if (!decodeTokenData(token)) return null;

  return decodeDataToken(token);
};

export const decodeDataToken = (token) => {
  const {
    name,
    lastname,
    email,
    phone,
    sub_role,
    payment_type,
    enterprise_id,
    commertial_name,
    igv,
  } = decodeTokenData(token) || {};
  return {
    name,
    lastname,
    email,
    phone,
    sub_role,
    payment_type,
    enterprise_id,
    commertial_name,
    igv,
  };
};
